/**
 * ReportSeed entity class
 */

/**
 * ReportSeedFactory
 * returns ReportSeed entity class
 *
 * @class ReportSeedFactory
 * @memberof mwApp
 * @see mwApp
 * @return {Function} {@link models.ReportSeed} class
 *
 * @ngdoc factory
 * @name mwApp.factory:ReportSeedFactory
 */
/* @ngInject */
export default function ReportSeedFactory (Entity, onOffMixin) {
  /* === ReportSeed class === */

  /**
   * ReportSeed model
   *
   * @class ReportSeed
   * @classdesc ReportSeed model
   * @memberof models
   * @see models
   * @extends models.Entity
   * @mixes models.onOffMixin
   * @param {Object} [object] - initial object, containing ReportSeed entity fields
   * @return {models.ReportSeed} ReportSeed entity
   */
  function ReportSeed () {
    var obj = Entity.apply(this, arguments)
    if (obj) {
      return obj
    }
  }
  ReportSeed.prototype = Object.create(Entity.prototype)
  ReportSeed.prototype.constructor = ReportSeed

  /* === User instance methods & fields === */

  Object.assign(ReportSeed.prototype, {

    /**
     * instance fields
     *
     * @memberof models.ReportSeed#
     * @type {Object}
     */
    _fields: {
      name: String,
      reportType: String,
      networkId: Number,
      filterList: ['Filter'],
      fieldList: [String]
    }
  }, onOffMixin)

  /* === User static methods & fields === */

  // copy all static methods from Entity class
  Object.assign(ReportSeed, Entity)
  ReportSeed._name = 'ReportSeed'
  ReportSeed.init()

  // permissions
  // ReportSeed.access = {
  //   view: 'viewReport',
  //   create: 'createReport',
  //   delete: 'deleteReport'
  // }

  return ReportSeed
}
